// extracted by mini-css-extract-plugin
export default {"aboutSwiper":"Card_aboutSwiper__Xe03o","carouselImage":"Card_carouselImage__z2aeJ"};